import { render, staticRenderFns } from "./ChronicAbsenceCard.vue?vue&type=template&id=37f11890&scoped=true"
import script from "./ChronicAbsenceCard.vue?vue&type=script&lang=js"
export * from "./ChronicAbsenceCard.vue?vue&type=script&lang=js"
import style0 from "./ChronicAbsenceCard.vue?vue&type=style&index=0&id=37f11890&prod&lang=scss"
import style1 from "./ChronicAbsenceCard.vue?vue&type=style&index=1&id=37f11890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f11890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSpacer})
